export default __webpack_public_path__ + "static/kuroemame-796b1cac2d84660bae7fb3822ab2813e.jpg";